import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { styled } from 'styled-components';
import { ForgotPasswordPage } from './ForgotPasswordPage';
import { LoginPage } from './LoginPage';
import { LogoutPage } from './LogoutPage';

export function LoginRoutes() {
  return (
    <Routes>
      <Route
        element={
          <FullScreen>
            <Outlet />
          </FullScreen>
        }
      >
        {/* Login page */}
        <Route path="login" element={<LoginPage />} />

        {/* Logout page which is only needed by angularjs to logout */}
        <Route path="logout" element={<LogoutPage />} />

        {/* Forgot password page (password reset page) */}
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
      </Route>
    </Routes>
  );
}

const FullScreen = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
`;
